import { useContext, useState } from "react"
import { AppContext } from "../../../contextApi/ContextApi";


export default function CheckBoxItem({radioLabel, radioAction, urlValue=null, hasFlag, flag, subType, subLabel, subAction, desc, preValue=""}) {
    const {accent_color, primary_color} = useContext(AppContext);
    const [hasInfo,setHasInfo] = useState(false);
    
    return (
        <div className="checkBoxItem">
            <div className="checkBoxItem_radioDiv">
                <label dir="rtl" className="checkBoxItem_radioLabel">{radioLabel}</label>
                <input className="checkBoxItem_radioInput" style={{backgroundColor:flag ? accent_color : "transparent", color:primary_color}} type="checkbox" onChange={radioAction} checked={flag}/>
            </div>
            {hasFlag && flag && 
            <div style={{position:"relative"}} className="checkBoxItem_textDiv">
                {!urlValue ? <input className="checkBoxItem_textInput" type={subType} onChange={subAction} value={preValue}/> : 
                <input className="checkBoxItem_textInput" type={subType} onChange={subAction} value={urlValue} placeholder={"הכנס קישור אליו ברצונך שהלינק יעביר את הלקוח"}/>
                }
                {subLabel !== null && <label dir="rtl" className="checkBoxItem_textLabel">{subLabel}</label>}
                <div className="checkBoxItem_infoDiv" style={{backgroundColor:accent_color, color:primary_color}} onMouseEnter={()=>{setHasInfo(true)}} onMouseLeave={()=>{setHasInfo(false)}}>?</div>

                {hasInfo && <div dir="rtl" className="checkBoxItem_info" style={{backgroundColor:accent_color,color:primary_color}} onMouseEnter={()=>{setHasInfo(true)}} onMouseLeave={()=>{setHasInfo(false)}}>{desc}</div>}
            </div>
            }
        </div>
    )
}
